import { Component, HostListener, NgZone, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { HeaderComponent } from './components/header/header';
import { FooterComponent } from './components/footer/footer';
import { ModalComponent } from './components/shared/modal/modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeaderComponent, FooterComponent, ModalComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  title = 'REHOBOT';
  private pressedKeys = new Set<string>();
  
  constructor(
    private router: Router, 
    private zone: NgZone,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit(): void {
    // Lógica de inicialización si es necesaria, la del modal ya no va aquí.
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    const key = event.key?.toLowerCase();
    if (!key) return;
    this.pressedKeys.add(key);

    // Atajo: Z + X
    if (this.pressedKeys.has('z') && this.pressedKeys.has('x')) {
      event.preventDefault(); // Previene acciones por defecto del navegador.
      this.pressedKeys.clear(); // Limpia las teclas para evitar repetición.

      this.zone.run(() => {
        console.log('✅ Atajo Z+X detectado. Redirigiendo a /admin/login...');
        this.router.navigate(['/admin/login']);
      });
    }
  }

  @HostListener('window:keyup', ['$event'])
  handleKeyUp(event: KeyboardEvent) {
    const key = event.key?.toLowerCase();
    if (!key) return;
    this.pressedKeys.delete(key);
  }
}

